import React from 'react';
import Requisitions from '../../utils/requisitions/Requisitions';
import SimpleInput from './SimpleInput';
import WS from '../../config/Ws';

import './text-input.css';


class TextInputWithUploader extends React.Component{
  constructor( props ){
    super(props);

    this.fileSelected =  this.fileSelected.bind(this);

    this.state = {
      title: props.title ? props.title : "Title",
      placeholder: props.placeholder ? props.placeholder : "",
      classes : props.classes ? props.classes : "",
      value : props.value ? props.value : "",
      name : props.name ? props.name : "",
      type : props.type ? props.type : 'text',
      url: props.url ? props.url : WS.uploader,
      onChange: props.onChange ? props.onChange : this.fileSelected
    }
  }

  fileSelected (e) {
    var _self = this;
    const formData = new FormData();
    formData.append('file',e.target.files[0]);

    Requisitions({
			url:this.state.url,
			data:formData,
			sucess:function(data){
        _self.setState({value:data.file});
			},
			error:function(data){
				console.log(data);
			}
		});
  }

  render(){
    const { title, placeholder, value, name, type } = this.state;

    return (
      <div>
        <div className="pure-u-20-24">
          <div className="box-input">
              <div className="box-input--title">{title}</div>
              <div className="box-input--border">
                <div className="box-input--inner">
                  <SimpleInput key={Math.floor(Math.random()*100)} readonly='readonly' placeholder={placeholder} value={value} name={name} type={type} />
                </div>
              </div>
          </div>
        </div>
        <div className="pure-u-4-24">
        <div className="box-input">
            <button type="button" className="box-input--border button-upload js-button-upload">
              <div className="box-input--inner">
                <i className="fas fa-cloud-upload-alt"></i>
                <input key={Math.floor(Math.random()*100)} name='fileSelect' onChange={this.fileSelected} className="box-input--file" type="file"></input>
              </div>
            </button>
        </div>
        </div>
      </div>
    )
  }
}
/*
const TextInputWithUploader = (
  {
    title="Title",
    placeholder="Placeholder",
    classes = "",
    value = "",
    name = "",
    type='text',
    ...props
  }
) => {
    return (
      <div>
        <div className="pure-u-20-24">
          <div className="box-input">
              <div className="box-input--title">{title}</div>
              <div className="box-input--border">
                <div className="box-input--inner">
                  <SimpleInput readonly='readonly' placeholder={placeholder} value={value} name={name} type={type} />
                </div>
              </div>
          </div>
        </div>
        <div className="pure-u-4-24">
        <div className="box-input">
            <button type="button" className="box-input--border button-upload js-button-upload">
              <div className="box-input--inner">
                <i className="fas fa-cloud-upload-alt"></i>
                <input className="box-input--file" type="file"></input>
              </div>
            </button>
        </div>
        </div>
      </div>
    );
}*/

export default TextInputWithUploader;



// WEBPACK FOOTER //
// ./src/components/form/TextInputWithUploader.js